export type GroupWorkLocation = 'offshore' | 'onshore_onsite';

export const GROUP_WORK_LOCATION_OPTIONS: { value: GroupWorkLocation; label: string }[] = [
  { value: 'offshore', label: 'Offshore' },
  { value: 'onshore_onsite', label: 'Onshore/OnSite' },
];

export const DEFAULT_GROUP_WORK_LOCATION: GroupWorkLocation = 'offshore';

export function formatGroupWorkLocation(value: string | undefined | null): string {
  const match = GROUP_WORK_LOCATION_OPTIONS.find((o) => o.value === value);
  return match?.label ?? 'Offshore';
}

export function getGroupWorkLocationBadgeClass(value: string | undefined | null): string {
  if (value === 'onshore_onsite') {
    return 'bg-amber-100 text-amber-800';
  }
  return 'bg-sky-100 text-sky-800';
}
